@if (featureType) {
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <!-- use fdx surface alert -->
        <fdx-surface-alert
            [tier]="tier"
            [dismissible]="dismissible"
            [iconOverrideContent]="iconOverride"
            [title]="featureType.titleHTML"
            [separateTitle]="separateTitle"
            [body]="inlineLinks ? undefined : featureType.descriptionHTML"
            [extraContent]="inlineLinks ? undefined : buttonContent"
            (dismissed)="onDismissed()">
            @if (inlineLinks) {
                <ng-container [ngTemplateOutlet]="inlineLinkContent"></ng-container>
            }
        </fdx-surface-alert>
    </div>
}

<ng-template #iconOverride>
    <fdx-surface-tier-icon-button
        [clickable]="false"
        [tier]="tier"
        size="sm"
        class="pt-1"/>
</ng-template>

<ng-template #buttonContent>
    @if (featureType.plansButtonText || featureType.productsButtonText || canRememberDismissed) {
        <div class="hstack gap-2">
            @if (featureType.plansButtonText && plansUrl) {
                <a [href]="plansUrl"
                   class="btn"
                   [ngClass]="planButtonClass"
                   target="_blank"
                   rel="noopener"
                   referrerpolicy="no-referrer">
                    <span>{{featureType.plansButtonText}}</span>
                    <fa-icon [icon]="faArrowUpRightFromSquare" class="ps-2 no-margin"/>
                </a>
            }

            @if (featureType.productsButtonText && productsUrl) {
                <a [href]="productsUrl"
                   class="btn btn-link text-iris"
                   target="_blank"
                   rel="noopener"
                   referrerpolicy="no-referrer">
                    <span>{{featureType.productsButtonText}}</span>
                    <fa-icon [icon]="faArrowUpRightFromSquare" class="ps-2 no-margin"/>
                </a>
            }

            @if (canRememberDismissed) {
                <div>
                    <form [formGroup]="mainForm">
                        <fdx-form-field
                            [formControlName]="formControlName"
                            [classes]="{'form-check-inline': true}">
                            <fdx-input-checkbox></fdx-input-checkbox>
                            <fdx-label>Don't remind me again about this</fdx-label>
                        </fdx-form-field>
                    </form>
                </div>
            }
        </div>
    }
</ng-template>

<ng-template #inlineLinkContent>
    @if (featureType.inlineTextLinks) {
        <span class="fw-bold pe-1" [innerHTML]="featureType.descriptionHTML | prettyHtml"></span>

        @for (link of featureType.inlineTextLinks; track link.text; let first = $first) {
            @if (!link.link
            || (link.link === 'plans' && !plansUrl)
            || (link.link === 'products' && !productsUrl)) {
                <span [ngClass]="first ? '' : 'ps-1'">{{link.text}}</span>
            } @else {
                <a [href]="link.link === 'plans' ? plansUrl : productsUrl"
                   class="d-inline btn-link unstyled-button"
                   [ngClass]="[textClass, first ? '' : 'ps-1']"
                   target="_blank"
                   rel="noopener"
                   referrerpolicy="no-referrer">
                    <span>{{link.text}}</span>
                </a>
            }
        }
        <span>.</span>
    }
</ng-template>
